export const evidenceDiaryDetailSearchFields = {
    INTERNAL_APP_PROPERTY_ID: 'internalAppPropertyId',
    FULL_NAME_SELLER: 'sellerFullName',
    LOCATION: 'propertyLocation',
    STREET: 'propertyStreet',
    PRICE_FROM: 'priceFrom',
    PRICE_TO: 'priceTo',
    CREATED_FROM: 'createdFrom',
    CREATED_TO: 'createdTo',
}
